import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';

interface BackButtonProps {
    backUrl?: string;
}

function BackButton({ backUrl }: BackButtonProps) {
    const navigate = useNavigate();
    
    const handleBack = () => {
        if (backUrl) {
            navigate(backUrl);
        } else {
            navigate(-1);
        }
    };
    
    return (
        <IconButton 
            onClick={handleBack}
            sx={{ 
                color: 'text.primary',
                '&:hover': {
                    bgcolor: 'action.hover'
                }
            }}
        >
            <ArrowBackIcon />
        </IconButton>
    );
}

export default BackButton;


